import React, { Component } from 'react'
import { observer } from 'mobx-react'
import { Link, withRouter } from 'react-router-dom'
import PropTypes from 'prop-types'

class ClientContactSearchResults extends Component {
  static propTypes = {
    clientContactSearchStore: PropTypes.object,
    baseUrl: PropTypes.string
  }

  onLink = id => {
    const { clientContactSearchStore } = this.props
    clientContactSearchStore.selectedContact = id
  }

  renderStatus (contact) {
    const activeInactive = contact.status ? 'active' : 'inactive'
    return (
      <div className={`status-label status-label-${activeInactive} m-l-m`}>
        {activeInactive.toUpperCase()}
      </div>
    )
  }

  render () {
    const {
      contactsData,
      numberOfContacts,
      selectedContact
    } = this.props.clientContactSearchStore
    const contactItem = 'search-item contacts'
    const { baseUrl } = this.props
    return (
      <div>
        <div className='expert-search-header no-of-contacts'>
          <h4 className='expert-search-total'>
            {numberOfContacts} client contacts
            {!numberOfContacts && (
              <span className='expert-search-total-message'>
                {' '}
                match the current search parameters
              </span>
            )}
          </h4>
        </div>
        {contactsData.map(contact => {
          return (
            <div key={contact.id}>
              <div className='expert-search-item-container'>
                <Link
                  onClick={e => this.onLink(contact.id)}
                  to={`${baseUrl}/client-contact/${contact.id}`}
                >
                  <div
                    className={
                      selectedContact === contact.id
                        ? `${contactItem} active`
                        : contactItem
                    }
                  >
                    {contact.knowledgeManager ? (
                      <div className='pull-right'>
                        <div className='status-label'>
                          <span>KM</span>
                        </div>
                      </div>
                    ) : null}
                    <div>
                      <span className='name'>
                        {contact.title} {contact.fullName}
                      </span>
                      <div>
                        {contact.companyName}, {contact.country}{' '}
                      </div>
                    </div>
                  </div>
                </Link>
              </div>
            </div>
          )
        })}
      </div>
    )
  }
}

export default withRouter(observer(ClientContactSearchResults))
